import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  text = 'SÍ, QUIERO EL MEGA PACK TERAPÉUTICO',
  subtext,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  return <a href="https://pagos.ebookditales.com/cart/47835561164955:1" className={`group relative flex flex-col items-center justify-center bg-gradient-to-r from-purple-600 to-purple-800 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all duration-300 ${fullWidth ? 'w-full' : 'w-full md:w-auto'} ${className}`} data-id="element-60">
      <div className="flex items-center gap-2 text-lg md:text-xl uppercase tracking-wide" data-id="element-61">
        <span data-id="element-62">{text}</span>
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-63" />
      </div>
      {subtext && <span className="text-xs md:text-sm font-medium text-purple-100 mt-1 opacity-90" data-id="element-64">
          {subtext}
        </span>}

      {/* Shine effect */}
      <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none" data-id="element-65">
        <div className="absolute top-0 left-[-100%] w-1/2 h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-[-25deg] animate-shine" data-id="element-66" />
      </div>
    </a>;
}